import React from 'react';
import styled from 'styled-components';
import {CenteredGrid, Eyebrow, GridContainer, Typography as Text, VerticalSpacer} from '..';
import {AccentColorOptions, useBreakpointUp} from 'epic-ue-theme';
import {AnimateOnViewWrap} from '../../wraps/animation';
import {QuoteIcon} from '../icons/QuoteIcon';
import {QuoteRoundedIcon} from '../icons/QuoteRoundedIcon';
import {Spotlight} from '../../wraps';
import Grid from '@material-ui/core/Grid';
import {useUnrealUIContext} from '../../../shared/context/componentContext';

const Styled = styled.div`
    svg {
        font-size: 68px;
        ${(p) => p.theme.breakpoints.down('sm')} {
            font-size: 56px;
        }
    }
    .paragraph {
        letter-spacing: 0.2px;
    }
    &&#largeQuote .h2.big {
        text-transform: none;
    }
`;

export interface LargeQuoteProps {
    title?: string;
    eyebrow?: string;
    description?: string;
    accentColor?: AccentColorOptions;
    spotlightImage?: string;
}

export const LargeQuote = ({
    description,
    eyebrow,
    title = '',
    accentColor = 'sky',
    spotlightImage
}: LargeQuoteProps): JSX.Element => {
    const mdUp = useBreakpointUp('md');

    const {quoteIcon} = useUnrealUIContext();

    return (
        <AnimateOnViewWrap translateY={30}>
            <Styled id="largeQuote" className="ue-large-quote">
                <GridContainer>
                    <CenteredGrid>
                        {mdUp ? <Grid item md={2} /> : ''}
                        <Grid item xs={12} md={8}>
                            <Spotlight
                                showImage={Boolean(spotlightImage)}
                                image={spotlightImage || ''}
                                accentColor={accentColor}
                                variant="small"
                                opacity={0.7}
                                offsetRatio={[-0.3, -3.5]}
                                offsetRatioDown={[-0.3, -3.5]}>
                                {quoteIcon?.icon === 'rounded' ? (
                                    <QuoteRoundedIcon color={accentColor} />
                                ) : (
                                    <QuoteIcon color={accentColor} />
                                )}
                            </Spotlight>
                            <VerticalSpacer variant="custom" spacing={5} />
                            {title && (
                                <Text variant="h2" big>
                                    {title}
                                </Text>
                            )}
                            <VerticalSpacer variant="custom" spacing={5} downSmSpacing={4} />
                            {eyebrow && (
                                <>
                                    <Eyebrow text={eyebrow} />
                                    <VerticalSpacer
                                        variant="custom"
                                        spacing={1}
                                        downSmSpacing={0}
                                    />
                                </>
                            )}
                            {description && (
                                <div className="description">
                                    <Text variant="p">{description}</Text>
                                </div>
                            )}
                        </Grid>
                    </CenteredGrid>
                </GridContainer>
            </Styled>
        </AnimateOnViewWrap>
    );
};
